<template>
  <v-container fill-height>
    <v-layout column fill-height>
      <v-row no-gutters>
        <v-spacer />
        <v-col cols="9" align-self="center" class="text-center">
          <v-img src="@/assets/img/success-variant-2.svg" max-width="140px" max-height="140px" class="mx-auto mb-8" />

          <h2 class="mb-4">Спасибо за регистрацию!</h2>

          <p>Вам необходимо пройти интервью с нашим сотрудником, чтобы активировать вашу учетную запись.</p>
          <p>Дождитесь звонка от сотрудников поддержки, мы работаем <b>по будням с 9 до 18 по московскому времени</b>. Если с вами не связались в течение дня, можете обратиться к нам:</p>
        </v-col>
        <v-spacer />
      </v-row>
      <v-row no-gutters>
        <v-spacer />
        <v-col cols="9" sm="4" md="3" xl="2">
          <v-list tag="ul">
            <v-list-item tag="li">
              <v-list-item-icon>
                <v-img src="@/assets/img/social/telegram.svg" alt="Telegram" />
              </v-list-item-icon>
              <v-list-item-content>
                <a href="https://t.me/modul_partner_bot" target="_blank" class="text-decoration-none" title="Telegram">@modul_partner_bot</a>
              </v-list-item-content>
            </v-list-item>
            <v-list-item tag="li">
              <v-list-item-icon>
                <v-img src="@/assets/img/social/phone-bubble.svg" alt="Whatsapp" />
              </v-list-item-icon>
              <v-list-item-content>
                <a href="https://wa.me/79958881703" target="_blank" class="text-decoration-none" title="Whatsapp">+7 (995) 888-17-03</a>
              </v-list-item-content>
            </v-list-item>
            <v-list-item tag="li">
              <v-list-item-icon>
                <v-icon color="primary">mdi-email-outline</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <a href="mailto:agent@modulbank.ru" target="_blank" class="text-decoration-none" title="Эл. почта">agent@modulbank.ru</a>
              </v-list-item-content>
            </v-list-item>
            <v-list-item tag="li">
              <v-list-item-icon>
                <v-icon color="primary">mdi-phone-outline</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <a href="tel:88004441085" target="_blank" class="text-decoration-none primary--text">8 (800) 444-10-85</a>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-col>
        <v-spacer />
      </v-row>
    </v-layout>
  </v-container>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'WaitConfirm',

  data: () => ({
    waitConfirmTimerHandle: null,
    isMounted: false,
  }),

  mounted() {
    Promise.all([
      this.$store.dispatch("reset"),
      this.$store.dispatch("profile/get")
    ]).then(() => {
      if (this.waitPersonConfirm) {
          this.waitConfirmTimerHandle = setInterval(() => {
          this.$store.dispatch("profile/get");
        }, 60000);
      } else {
        this.$router.push({ name: "Cabinet" });
      }

      this.isMounted = true;
    });
  },

  destroyed() {
    if (this.waitConfirmTimerHandle) {
      clearInterval(this.waitConfirmTimerHandle);
      this.waitConfirmTimerHandle = null;
    }
  },

  computed: {
    ...mapGetters({ waitPersonConfirm: "profile/waitPersonConfirm" }),
  },

  watch: {
    waitPersonConfirm(v) {
      if (this.isMounted && v === false) {
        this.$router.push({ name: 'Cabinet' });
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.v-list {
  background: none !important;
}

ul {
  padding-left: 0;
}

.v-list-item {
  justify-content: center;
  padding-left: 0;
  padding-right: 0;

  &__content {
    overflow: unset;

    @media screen and (min-width: 425px) {
      flex-grow: 0.75;
    }
  }
  &__icon {
    margin-left: 0 !important;
    margin-right: 8px !important;
  }
}
</style>
